import type { IReview } from "@api/models/IReview";
import ArrayHelper from "@helpers/array.helper";
import dayjs from "dayjs";

const CTA_REVIEW: IReview = {
  id: -1,
  author: "",
  comment: "",
  date: dayjs(),
  grade: 0,
  type: "cta",
  url: "",
};

const CTA_FREQUENCY = 13;

export class ReviewHelper {
  static REVIEW_COUNT = 116;
  static AVERAGE_GRADE = 4.6;

  static getCtaReview = (index: number): IReview => {
    return { ...CTA_REVIEW, id: -1 * (index + 1) };
  };

  /**
   * Splits the reviews into the specified number of parts and adds CTA reviews at a regular interval.
   */
  static splitReviews = (array: IReview[], parts: number) => {
    const reviewsWithCTA = array.flatMap((review, i): IReview[] => {
      const isIndexForCTA = (i + 1) % CTA_FREQUENCY === 0;
      return isIndexForCTA ? [review, ReviewHelper.getCtaReview(i)] : [review];
    });

    return ArrayHelper.splitArray(reviewsWithCTA, parts);
  };

  static LOADING_REVIEWS: IReview[] = [
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -1,
      url: "",
      type: "skeleton",
      comment:
        "Jamais eu 1 seul ban en 4 comptes achetés, compte obtenu instantanément, service client à l’affût bref c’est nickel",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -2,
      url: "",
      type: "skeleton",
      comment: "Super rapide je recommande-",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -3,
      url: "",
      type: "skeleton",
      comment:
        "Compte reçu instantanément et fonctionnel, si vous chercher des comptes à des prix cohérent je recommande.",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -4,
      url: "",
      type: "skeleton",
      comment:
        "J'ai recu mon compte, instantanément, le staff répond dans la minute. Je conseille ce site a tout ceux qui veulent acheter un compte LOL",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -5,
      url: "",
      type: "skeleton",
      comment:
        "Je me suis trompée d'achat et le service client m'a offert un compte car je suis un client trés régulier jamais eu aucun soucis avec le site sur plusieurs achat",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -6,
      url: "",
      type: "skeleton",
      comment:
        "Super j'ai eu un peu peur au début mais trop bien le skin était la j'ai eu un skin de cait en bonus je suis joie trop bien merci <3",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -7,
      url: "",
      type: "skeleton",
      comment: "Rapide efficace repond a ma demande",
    },
    {
      author: "SECRET SMURFS",
      date: dayjs(),
      grade: 5,
      id: -8,
      url: "",
      type: "skeleton",
      comment: "Super rapide je recommande",
    },
  ];
}
